import { getCurrentRescueOfDriver } from 'src/backend/rescues';
import { useQuery } from '@tanstack/react-query';

export default function useGetCurrentRescueDriver({
  lat = null,
  lng = null,
  ...options
} = {}) {
  return useQuery({
    queryKey: ['current-rescue-of-driver', lat, lng],
    queryFn: () => getCurrentRescueOfDriver({ lat, lng }),
    ...options,
    refetchOnWindowFocus: false,
  });
}
